import React, { useEffect } from 'react';

import { UiDialog as Dialog } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { createStructuredSelector } from 'reselect';

import * as actions from './actions';
import LoadsForm from './components/LoadsForm';
import * as selectors from './selectors';

const Container = ({ closeModal, isOpenModal, reset }) => {
    const { t } = useTranslation();

    useEffect(() => {
        return () => reset();
    }, []);

    return (
        <Dialog
            onClose={() => closeModal()}
            onExited={() => closeModal()}
            open={isOpenModal}
            title={`${t('Update')} ${t('Project').toLowerCase()}`}
            size="sm"
        >
            <LoadsForm />
        </Dialog>
    );
};

const mapStateToProps = createStructuredSelector({
    isOpenModal: selectors.getIsOpenModal,
});

const mapDispatchToProps = (dispatch) => ({
    closeModal: () => dispatch(actions.closeModal()),
    reset: () => dispatch(actions.reset()),
});

Container.propTypes = {
    closeModal: PropTypes.func,
    isOpenModal: PropTypes.bool,
    reset: PropTypes.func,
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
)(Container);
